var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { editPipelineRequest } from "../../../../api/api";
import { CLOSE_PIPELINE_MODAL, PIPELINE_EDIT_PIPELINE, } from "../../../../constants";
import { DispatchType, useModal } from "../../../../hooks/useModal";
import { ModalContext } from "../../../../providers/ModalContextProvider";
import { WPQTModal } from "../../WPQTModal";
import { EditPipelineModalContent } from "./EditPipelineModalContent";
function EditPipelineModal() {
    const { state: { pipelineModalOpen }, } = useContext(ModalContext);
    const { modalSaving, setModalSaving, modalContentRef, closeModal, handleSuccess, handleError, } = useModal(CLOSE_PIPELINE_MODAL);
    const editPipeline = (pipeline) => __awaiter(this, void 0, void 0, function* () {
        try {
            setModalSaving(true);
            const response = yield editPipelineRequest(pipeline);
            handleSuccess(PIPELINE_EDIT_PIPELINE, response.data, DispatchType.ACTIVE_PIPELINE);
        }
        catch (error) {
            handleError(error);
        }
    });
    return (_jsx(WPQTModal, { modalOpen: pipelineModalOpen, closeModal: closeModal, size: "xl", children: _jsx(EditPipelineModalContent, { ref: modalContentRef, editPipeline: editPipeline, modalSaving: modalSaving, setModalSaving: setModalSaving }) }));
}
export { EditPipelineModal };
